import { plainTextFromHTML } from "./plainTextFromHTML";

// Parses the <span data-kerning="1"> tags emitted by applyKerningOverrides
// from a serialized HTML string. Returns one descriptor per span in document
// order: the wrapped character, the letter-spacing value, and the span's
// plain-text position (chars before it, with <br> counted as 1 — mirrors the
// indexing applyKerningOverrides itself uses). Position lets the edit-mode
// in-place style update path match by location rather than greedy-char order,
// so repeated characters don't cause a kerning value to shift onto the wrong
// span when one of them clears across zero.

export interface KerningSpanInfo {
  value: string;
  char: string;
  position: number;
}

const KERNING_SPAN_REGEX = /<span\s+data-kerning="1"\s+style="letter-spacing:\s*([^"]+);">([^<]*)<\/span>/g;

// Decode HTML entities in the captured span char (e.g. &amp; → &) so the
// returned value matches the decoded el.textContent the in-place style update
// path compares against. Without this, any kerning of &/<>/nbsp silently falls
// through to the full-rewrite path.
const decodeHTMLEntities = (s: string): string => {
  if (!s || s.indexOf("&") === -1) return s;
  const tmp = document.createElement("textarea");
  tmp.innerHTML = s;
  return tmp.value;
};

export const parseKerningSpans = (html: string): KerningSpanInfo[] => {
  if (!html) return [];
  const out: KerningSpanInfo[] = [];
  for (const m of html.matchAll(KERNING_SPAN_REGEX)) {
    const matchIndex = m.index ?? 0;
    const position = plainTextFromHTML(html.slice(0, matchIndex)).length;
    out.push({
      value: (m[1] ?? "").trim(),
      char: decodeHTMLEntities(m[2] ?? ""),
      position
    });
  }
  return out;
};
